
import { FaEnvelope, FaFacebook, FaInstagram, FaMapMarker, FaPhoneAlt } from 'react-icons/fa'
import '../styles/Contacts.css'
import emailjs from 'emailjs-com';

import React, { useRef, useState } from 'react'

function Contacts() {
    const formRef = useRef();
    const [done, setDone] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        emailjs
            .sendForm('service_bvbq68p', 'template_przth06', formRef.current, 'i7jD0IWwxKPm6Jb4b')
            .then((result) => {
                console.log(result.text);
                setDone(true);
            }, (error) => {
                console.log(error.text);
            });
            e.target.reset();
    }
    return (
        <div>
            <div>
                <h1 className="contact-header"> Contacts</h1>
            </div><br /><br />
            <div className="contacts-div">
                <div className="contact-inform-div">
                    <h1>
                        Let's discuss your fitness
                    </h1>
                    <div className="contactpage-links">
                        <p><em><FaPhoneAlt /></em> 0705-863-820, 0705-673-263</p>
                        <p><em><FaEnvelope /> </em>wazitofitnessnrb@gmail.com</p>
                        <p><em><FaMapMarker /></em> Located in Lucky Summer,Ruaraka</p>
                    </div>
                    <div className="follow-contacts">
                        <h3>Follow us:</h3>
                        <div className="cont-links">
                            <p className="a-link"><a href="https://www.facebook.com/wazitofitnessgym/" target="_blank" rel="noreferrer"><FaFacebook /> </a></p>
                            <p className="a-link"><a href="https://www.instagram.com/tv/Cb-nbV3jWCc/?utm_medium=share_sheet" target="_blank" rel='noreferrer'><FaInstagram /></a></p>
                        </div>
                    </div>
                </div>
                <div className="myform">
                    <h1>Get in touch. Our team is always available to help you workout</h1>
                    <h3>With our team, you can always achieve your fitness dreams</h3>
                    <form ref={formRef} onSubmit={handleSubmit} className="contacts-form">
                        <input type="text" name="user_name" placeholder="Name" required /> <br />
                        <input type="text" name="user_subject" placeholder="Subject" required /> <br />
                        <input type="email" name="user_email" placeholder="Email" requited /> <br />
                        <textarea type="text" cols="50" rows="8" name="message" placeholder="Message..." required /> <br />
                        <button className="contacts-button">Connect Us</button>
                        {done && 'Sent. Thank you'}
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Contacts
